import { render } from "./ChangeRequestRejectModal.vue?vue&type=template&id=1ba8bee8"
import script from "./ChangeRequestRejectModal.vue?vue&type=script&lang=js"
export * from "./ChangeRequestRejectModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__